import * as React from 'react';
import { observer } from 'mobx-react';
import { FormTemplate } from '../../../../../../../../Resource/FormTemplates/Types';
import WithField from '../../../../../../../../Resource/FormTemplates/Inputs/WithField';
import MultipleSelectionsInput from '../../../../../../../../Resource/FormTemplates/Inputs/MultipleSelectionsInput';
import { T } from '../../../../../../../../Translations';

interface Props {
  template: FormTemplate;
}

const SelectUserGroup: React.FC<Props> = ({ template }) => (
  <div className="ml-0 mb-6">
    <div className="text-md font-semibold">
      <T kind="Select Group" />
    </div>
    <WithField kind="single-selection" name="user_group_id" fields={template.fields}>
      {(field) => <MultipleSelectionsInput field={field} />}
    </WithField>
  </div>
);

export default observer(SelectUserGroup);
